<template>
  <div class="section">
    <div class="design-header">
      <h2 class="title">{{ sectionDisplayName }}</h2>
    </div>
    <div class="text-box">
      <!-- セクション本体のスタイル -->
      <unit-container
        v-for="(container, index) in containers"
        :key="index"
        :sectionName="sectionName"
        :sectionDisplayName="sectionDisplayName"
        :target="container.target"
        :styles="container.styles"
      />
      <!-- テキストのスタイル -->
      <section-text-style
        :sectionName="sectionName"
        :styles="styles"
        class="theme-text-style"
      />
      <!-- リンクテキストのスタイル -->
      <section-link-style
        :sectionName="sectionName"
        :selector="sectionLinkSelector"
        :styles="sectionLinkStyles"
        class="theme-link-style"
      />
    </div>
    <div class="design-footer">
      <button
        class="close normal-btn"
        @click="closeButton"
        data-shortcut-esc="editorCloseButton"
      >
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
import Base from '@/components/Content/Palette/ContentDesign/ContentDesignBase'
import ShortCutBase from '@/mixins/ShortCutBase'
import UnitContainer from '@/components/Content/Palette/ContentDesign/UnitContainer'
import SectionTextStyle from '@/components/Content/Palette/ContentDesign/Section/SectionTextStyle'
import SectionLinkStyle from '@/components/Content/Palette/ContentDesign/Section/SectionLinkStyle'

export default {
  name: 'content-design-section',
  mixins: [
    Base,
    ShortCutBase
  ],
  props: [
    'sectionName',
    'sectionDisplayName',
    'styles',
  ],
  data () {
    return {
      containers: [
        { target: 'container', styles: this.containerStyles },
        { target: 'inner', styles: this.innerStyles }
      ],
      // セレクタ：.section-header a の形
      sectionLinkSelector: `.section-${this.sectionName} a`,
    }
  },
  components: {
    UnitContainer,
    SectionTextStyle,
    SectionLinkStyle,
  },
  computed: {
    containerStyles: {
      cache: false,
      get () {
        return {
          background: this.styles['background'] || 'transparent',
          borderTop: this.styles['border-top'] || null,
          borderBottom: this.styles['border-bottom'] || null,
          paddingTop: this.styles['padding-top'] || '0px',
          paddingBottom: this.styles['padding-bottom'] || '0px',
        }
      }
    },
    innerStyles: {
      cache: false,
      get () {
        return {
          background: this.styles['inner_background'] || 'transparent',
          borderTop: this.styles['inner_border-top'] || null,
          borderBottom: this.styles['inner_border-bottom'] || null,
          paddingTop: this.styles['inner_padding-top'] || '0px',
          paddingBottom: this.styles['inner_padding-bottom'] || '0px',
        }
      }
    },
    // セクションのリンクスタイル：持ち方が違うため、セクションではなくコンテントのスタイルに保存されている
    sectionLinkStyles: {
      cache: false,
      get () {
        return this.$store.getters.findContentStyleAll(this.sectionLinkSelector)
      }
    },
  },
  watch: {
    containerStyles: {
      deep: true,
      handler: function (value) {
        this.containers.find(container => container.target === 'container').styles = value
      }
    },
    innerStyles: {
      deep: true,
      handler: function (value) {
        this.containers.find(container => container.target === 'inner').styles = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.design-header, .design-footer {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #dbdbdb;
  position: relative;
}
.design-header {
  border-top: 0.5px solid #dbdbdb;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  background: #f8f8f8;
  .btn {
    position: absolute;
    top: 10px;
    left: 20px;
    opacity: 0.5;
    font-size: 16px;
    margin: 0 !important;
    padding: 0 !important;
    background: none;
    border: none;
    color: $commonFontColor;
    transition: all 0.3s ease 0s;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f104';
      font-weight: 900;
      padding-right: 2px;
    }
    &:hover {
      opacity: 1;
    }
  }
  .title {
    color: $commonFontColor;
  }
}
.design-footer {
  vertical-align: bottom;
  border-top: #dbdbdb 1px solid;
  text-align: right;
  position: absolute;
  bottom: 0;
  .close {
    width: auto;
    display: block;
    font-size: 14px;
    border-radius: 5px;
    color: #fff;
    border: solid 1px #484848;
    background: #484848;
    opacity: 1;
    position: absolute;
    top: 6px;
    right: 8px;
    &:hover {
      background: #484848;
      opacity: 0.8;
    }
  }
}
.text-box {
  height: calc(100vh -  240px);
  overflow: auto;
}
</style>

<style lang="scss">
.theme-text-style {
  .window {
    top: -275px;
  }
}
.theme-link-style {
  .window {
    top: -275px;
    right: auto;
    left: 0;
  }
}
</style>
